/* eslint-disable max-len */
import { useState } from 'react';
import { TabList } from '@skyline-platform/alchemy';
import { BulkDelete } from './BulkDelete';
import './BulkActions.css';
import { ItemsProvider } from './utils/ItemsContext';
import PropTypes from 'prop-types';
import { bulkUpdate, getConfirmBtnState } from './utils/bulkUpdate';
import { AssignNetworkAddress } from './AssignNetworkAddress';

const deleteDescription = (<>
  <span>Delete cameras that are no longer needed.</span><br /><br />
  <span>Once updated, all selected cameras, associated streams, and stream profiles will be permanently removed from the system.</span>
</>);

const confirmDeleteDescription = (<>
  <span>Are you sure you want to delete the selected cameras?</span>
</>);

export const CameraBulkActions = ({ cameras, selectedCams }) => {
  const [confirmDelete, setConfirmDelete] = useState(false);

  return (
    <ItemsProvider selectedCameras={selectedCams} cameras={cameras}>
      <camera-bulk-actions>
        <TabList
          type='menu'
          tabs={['IP | Network Address', 'Delete Cameras']}
          tabsprops={{ orientation: 'vertical' }}
          pages={[
            <AssignNetworkAddress title='Assign Network Address' key='network-address' />,
            <BulkDelete
              title='Delete Cameras'
              key='delete'
              description={confirmDelete ? confirmDeleteDescription : deleteDescription}
              confirmBtnLabel={confirmDelete ? 'YES, DELETE CAMERAS' : 'Delete Cameras'}
              confirmBtnState={getConfirmBtnState(selectedCams, confirmDelete)}
              confirmAction={() => setConfirmDelete(() => {
                if (confirmDelete) {
                  bulkUpdate('delete_device', selectedCams, {});
                  return false;
                }
                return true;
              })}
            />,
          ]}
        />
      </camera-bulk-actions>
    </ItemsProvider>
  );
};

CameraBulkActions.propTypes = {
  cameras: PropTypes.array.isRequired,
  selectedCams: PropTypes.array.isRequired,
};